export const messages = {
  en: {
    updateStoreState: {
      confirmOperation: 'Please confirm your operation',
      confirmWhether: 'Confirm whether to',
      cancel: 'Canceled',
      confirm: 'Confirm'
    }
  },
  zh: {
    updateStoreState: {
      confirmOperation: '请确认您的操作',
      confirmWhether: '确认是否',
      cancel: '点错了',
      confirm: '确认'
    }
  }
}